module.exports = __webpack_public_path__ + "static/media/image-error-desktop.b9aa0782.jpg";